import { useEffect, useState } from "react"

//constants
import { ENDPOINTS } from "constants/endpoints"

//hooks
import useFetch from "hooks/useFetch"

function useFetchCategoriesTransactions(categoryId, startDate, endDate) {
    const { fetch, loading } = useFetch()
    const [transactions, setTransactions] = useState({})

    useEffect(() => {
        _fetchData()
    }, [startDate, categoryId,endDate])

    function _fetchData() {
        const params = `?task_type=${categoryId}&start_date=${startDate}&end_date=${endDate || 0}`

        fetch({ endpoint: `favour-reference${params}`, method: 'get' })
            .then(res => {
                setTransactions(res.data)
            })
    }

    function getTransactions() {
        return transactions
    }

    function refetchData() {
        _fetchData()
    }

    return {
        getTransactions,
        loading,
        refetchData,
    }
}

export default useFetchCategoriesTransactions